import * as ReactRedux from 'react-redux';
import * as actions from '../../redux/session/actions';
import {TryOut, ITryOutProps} from './try-out-ui';

const mapStateToProps = (): ITryOutProps => ({
  userId: '1',
});

const mapDispatchToProps: ReactRedux.MapDispatchToPropsObject = {
  webSocketCommand: actions.webSocketCommand,
  webSocketConnect: actions.webSocketConnect,
  webSocketDisconnect: actions.webSocketDisconnect,
};

export const TryOutContainer = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(TryOut);
